import { render, staticRenderFns } from "./color-defaultValue-editor.vue?vue&type=template&id=667e90e8&scoped=true&"
import script from "./color-defaultValue-editor.vue?vue&type=script&lang=js&"
export * from "./color-defaultValue-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667e90e8",
  null
  
)

export default component.exports